import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteItemCategoryApi } from "../../apiservice/inventory";
import { saveCategorieManageApi } from "../../apiservice/accounts";

export const saveCategory = createAsyncThunk(
  "categories/saveCategory",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveCategorieManageApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (category_id, { rejectWithValue }) => {
    try {
      const res = await deleteItemCategoryApi({ category_id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
